import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    [
      _vm.noProductsError
        ? _c(
            VAlert,
            { staticClass: "mt-4", attrs: { type: "error", prominent: "" } },
            [
              _vm._v(
                " Your account is not configured for any LME brand product. Please contact the administrator to set it up. "
              ),
            ]
          )
        : _c(
            VCard,
            [
              _c(
                VCardTitle,
                [
                  _vm._v(" LME Passport Management "),
                  _c(VSpacer),
                  _c(VSelect, {
                    staticClass: "ml-4",
                    staticStyle: { "max-width": "200px" },
                    attrs: {
                      items: _vm.statusOptions,
                      label: "Filter by Status",
                      clearable: "",
                    },
                    model: {
                      value: _vm.statusFilter,
                      callback: function ($$v) {
                        _vm.statusFilter = $$v
                      },
                      expression: "statusFilter",
                    },
                  }),
                  _c(
                    VBtn,
                    {
                      staticClass: "ml-4",
                      attrs: {
                        color: "primary",
                        loading: _vm.loadingSync,
                        disabled: _vm.loadingSync,
                      },
                      on: { click: _vm.syncStatuses },
                    },
                    [_vm._v("Sync Statuses")]
                  ),
                ],
                1
              ),
              _c(
                VCardSubtitle,
                [
                  _c(
                    VRow,
                    [
                      _c(
                        VCol,
                        { attrs: { cols: "12", md: "3" } },
                        [
                          _c(
                            VMenu,
                            {
                              attrs: {
                                "close-on-content-click": false,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "auto",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        VTextField,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: "Start Date",
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                              },
                                              model: {
                                                value: _vm.startDate,
                                                callback: function ($$v) {
                                                  _vm.startDate = $$v
                                                },
                                                expression: "startDate",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.startDateMenu,
                                callback: function ($$v) {
                                  _vm.startDateMenu = $$v
                                },
                                expression: "startDateMenu",
                              },
                            },
                            [
                              _c(VDatePicker, {
                                attrs: { "no-title": "" },
                                on: {
                                  input: function ($event) {
                                    _vm.startDateMenu = false
                                  },
                                },
                                model: {
                                  value: _vm.startDate,
                                  callback: function ($$v) {
                                    _vm.startDate = $$v
                                  },
                                  expression: "startDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12", md: "3" } },
                        [
                          _c(
                            VMenu,
                            {
                              attrs: {
                                "close-on-content-click": false,
                                transition: "scale-transition",
                                "offset-y": "",
                                "min-width": "auto",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        VTextField,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                label: "End Date",
                                                "prepend-icon": "mdi-calendar",
                                                readonly: "",
                                              },
                                              model: {
                                                value: _vm.endDate,
                                                callback: function ($$v) {
                                                  _vm.endDate = $$v
                                                },
                                                expression: "endDate",
                                              },
                                            },
                                            "v-text-field",
                                            attrs,
                                            false
                                          ),
                                          on
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.endDateMenu,
                                callback: function ($$v) {
                                  _vm.endDateMenu = $$v
                                },
                                expression: "endDateMenu",
                              },
                            },
                            [
                              _c(VDatePicker, {
                                attrs: { "no-title": "" },
                                on: {
                                  input: function ($event) {
                                    _vm.endDateMenu = false
                                  },
                                },
                                model: {
                                  value: _vm.endDate,
                                  callback: function ($$v) {
                                    _vm.endDate = $$v
                                  },
                                  expression: "endDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VCol,
                        { attrs: { cols: "12", md: "2" } },
                        [
                          _c(
                            VBtn,
                            {
                              staticClass: "mt-4",
                              attrs: {
                                color: "primary",
                                loading: _vm.loading,
                                disabled: _vm.loading,
                              },
                              on: { click: _vm.fetchInventories },
                            },
                            [_vm._v("Filter")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mx-4 my-2" },
                [
                  _c(VTextField, {
                    attrs: {
                      "append-icon": "mdi-magnify",
                      label: "Search",
                      "single-line": "",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                ],
                1
              ),
              _c(VDataTable, {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.inventories,
                  search: _vm.search,
                  loading: _vm.loading,
                  "loading-text": "Loading... Please wait",
                  "items-per-page": 10,
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.inventoryId",
                    fn: function ({ item }) {
                      return [
                        item.inventoryId
                          ? _c(
                              "a",
                              {
                                staticClass: "inventory-link",
                                on: {
                                  click: function ($event) {
                                    return _vm.openInventoryLookup(item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(item.inventoryId))]
                            )
                          : _c("span", [_vm._v("N/A")]),
                      ]
                    },
                  },
                  {
                    key: "item.coaReferenceNumber",
                    fn: function ({ item }) {
                      return [
                        _c("span", { staticClass: "mr-2" }, [
                          _vm._v(_vm._s(item.coaReferenceNumber)),
                        ]),
                        !item.hasLabResult
                          ? _c(
                              VTooltip,
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            VIcon,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "warning",
                                                  },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("mdi-alert")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("No lab result available")])]
                            )
                          : !item.signed
                          ? _c(
                              VTooltip,
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            VIcon,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "error",
                                                  },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("mdi-alert-circle")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("CoA not signed")])]
                            )
                          : item.hasCompositionExceeded
                          ? _c(
                              VTooltip,
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            VIcon,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "error",
                                                  },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("mdi-alert-octagon")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v("Composition exceeds LME standards"),
                                ]),
                              ]
                            )
                          : _c(
                              VIcon,
                              { attrs: { small: "", color: "success" } },
                              [_vm._v("mdi-check")]
                            ),
                      ]
                    },
                  },
                  {
                    key: "item.coaDate",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.formatDate(item.coaDate)) + " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.quality",
                    fn: function ({ item }) {
                      return [
                        _c("span", [_vm._v(_vm._s(item.quality || "N/A"))]),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function ({ item }) {
                      return [
                        _c(
                          VTooltip,
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        VIcon,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                small: "",
                                                disabled:
                                                  _vm.loadingActions[
                                                    item.coaReferenceNumber
                                                  ],
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.previewPayload(
                                                    item.coaReferenceNumber
                                                  )
                                                },
                                              },
                                            },
                                            "v-icon",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_vm._v("mdi-file-document-outline")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Preview Payload")])]
                        ),
                        _c(
                          VTooltip,
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        VIcon,
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass: "mr-2",
                                              attrs: {
                                                small: "",
                                                disabled:
                                                  _vm.loadingActions[
                                                    item.coaReferenceNumber
                                                  ],
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.previewPDF(
                                                    item.coaReferenceNumber
                                                  )
                                                },
                                              },
                                            },
                                            "v-icon",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_vm._v("mdi-file-pdf-box")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("Preview PDF")])]
                        ),
                        item.parentDocumentId
                          ? _c(
                              VTooltip,
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            VIcon,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    small: "",
                                                    disabled:
                                                      _vm.loadingActions[
                                                        item.coaReferenceNumber
                                                      ],
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewRecord(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("mdi-eye")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("View Record")])]
                            )
                          : _vm._e(),
                        item.status === "NOT_SUBMITTED" ||
                        item.status === "DRAFT" ||
                        item.status === "ERROR"
                          ? _c(
                              VTooltip,
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            VIcon,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    small: "",
                                                    disabled:
                                                      !item.hasLabResult ||
                                                      !item.signed ||
                                                      _vm.loadingActions[
                                                        item.coaReferenceNumber
                                                      ],
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.submitRecord(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("mdi-upload")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    "Submit Record (requires lab result and signing)"
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        item.parentDocumentId &&
                        !(
                          item.status == "APPROVED" ||
                          item.status == "PENDING_APPROVAL"
                        )
                          ? _c(
                              VTooltip,
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            VIcon,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  staticClass: "mr-2",
                                                  attrs: {
                                                    small: "",
                                                    disabled:
                                                      _vm.loadingActions[
                                                        item.coaReferenceNumber
                                                      ] || !item.signed,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.uploadDocument(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("mdi-file-upload")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      item.signed
                                        ? "Upload Document"
                                        : "Upload Document (requires signing)"
                                    )
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        item.status === "SUBMITTED" ||
                        item.status === "APPROVED"
                          ? _c(
                              VTooltip,
                              {
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function ({ on, attrs }) {
                                        return [
                                          _c(
                                            VIcon,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    small: "",
                                                    disabled:
                                                      _vm.loadingActions[
                                                        item.coaReferenceNumber
                                                      ],
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteRecord(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                "v-icon",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [_vm._v("mdi-delete")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Delete Record")])]
                            )
                          : _vm._e(),
                        _vm.loadingActions[item.coaReferenceNumber]
                          ? _c(VProgressCircular, {
                              staticClass: "ml-2",
                              attrs: {
                                indeterminate: "",
                                size: "16",
                                width: "2",
                                color: "primary",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "800" },
          model: {
            value: _vm.showJsonPreview,
            callback: function ($$v) {
              _vm.showJsonPreview = $$v
            },
            expression: "showJsonPreview",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, [_vm._v("JSON Payload Preview")]),
              _c(
                VCardText,
                [
                  _c(VCheckbox, {
                    attrs: { label: "Include Encoded CoA Text" },
                    model: {
                      value: _vm.includeEncodedCoaText,
                      callback: function ($$v) {
                        _vm.includeEncodedCoaText = $$v
                      },
                      expression: "includeEncodedCoaText",
                    },
                  }),
                  _c("pre", [_vm._v(_vm._s(_vm.jsonPreview))]),
                ],
                1
              ),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showJsonPreview = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "800", "max-height": "600" },
          model: {
            value: _vm.showPdfPreview,
            callback: function ($$v) {
              _vm.showPdfPreview = $$v
            },
            expression: "showPdfPreview",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                [
                  _vm._v(" PDF Preview "),
                  _c(VSpacer),
                  _vm.selectedItem &&
                  _vm.selectedItem.status === "SUBMITTED_MISSING_DOCUMENT"
                    ? _c(
                        VBtn,
                        {
                          attrs: {
                            color: "primary",
                            text: "",
                            disabled:
                              _vm.selectedItem &&
                              (_vm.loadingActions[
                                _vm.selectedItem.coaReferenceNumber
                              ] ||
                                !_vm.selectedItem.signed),
                          },
                          on: {
                            click: function ($event) {
                              return _vm.uploadDocument(_vm.selectedItem)
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.selectedItem.signed
                                  ? "Upload PDF"
                                  : "Upload PDF (requires signing)"
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(VCardText, [
                _vm.pdfPreviewUrl
                  ? _c("iframe", {
                      attrs: {
                        src: _vm.pdfPreviewUrl,
                        width: "100%",
                        height: "500px",
                      },
                    })
                  : _vm._e(),
              ]),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showPdfPreview = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "800" },
          model: {
            value: _vm.showRecordDetails,
            callback: function ($$v) {
              _vm.showRecordDetails = $$v
            },
            expression: "showRecordDetails",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, [_vm._v("Record Details")]),
              _c(VCardSubtitle, [
                _vm._v(
                  "Note: We can only view approved record from LME Passport"
                ),
              ]),
              _c(VCardText, [
                _c("pre", [_vm._v(_vm._s(_vm.recordDetails))]),
              ]),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showRecordDetails = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("inventory-lookup", {
        attrs: { activated: _vm.lookupInventory },
        on: {
          "update:activated": function ($event) {
            _vm.lookupInventory = $event
          },
          selected: _vm.handleInventorySelected,
        },
        model: {
          value: _vm.selectedInventoryId,
          callback: function ($$v) {
            _vm.selectedInventoryId = $$v
          },
          expression: "selectedInventoryId",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }